// removed by extract-text-webpack-plugin
module.exports = {"container":"_3B_W","wrapper":"_2_X9","title":"_2HCn","listItem":"Z2w3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/FooterColumn/styles.scss
// module id = 427
// module chunks = 0